<div fxLayout="row" fxLayoutAlign="start center" class="lina-coach {{theme}}">
  <mat-icon class="margin-right-5 {{theme}}">{{icon}}</mat-icon>
  <div>
    <h4 *ngIf="messageTitle"><b>{{messageTitle | translate}}</b></h4>
    <span [innerHTML]="content | translate"></span>
  </div>
</div>
